export const formatMetaDateTime = (value?: string) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const baseOptions: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  try {
    return date.toLocaleString("en-US", {
      ...baseOptions,
      timeZoneName: "shortOffset",
    });
  } catch {
    return date.toLocaleString("en-US", {
      ...baseOptions,
      timeZoneName: "short",
    });
  }
};
